import component from "./fr/component";
import layout from "./fr/layout";
import pages from "./fr/pages";

export default {
  ...layout,
  ...pages,
  ...component,
};
